import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth-context';
import { LiveProvider } from './lib/live-context';
import { Budget } from './pages/Budget';
import { Categories } from './pages/Categories';
import { Dashboard } from './pages/Dashboard';
import { History } from './pages/History';
import { Recurring } from './pages/Recurring';
import { Security } from './pages/Security';
import { SignIn } from './pages/SignIn';
import { Todos } from './pages/Todos';

export function App() {
  const { state } = useAuth();

  if (state.status === 'loading') {
    return <main className="center" aria-busy="true" />;
  }

  if (state.status === 'signedOut') {
    return <SignIn />;
  }

  return (
    <LiveProvider>
      <TopBar />
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/todos" element={<Todos />} />
        <Route path="/todos/recurring" element={<Recurring />} />
        <Route path="/budget" element={<Budget />} />
        <Route path="/history" element={<History />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/security" element={<Security />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </LiveProvider>
  );
}

function TopBar() {
  const { state, signOut } = useAuth();
  const name = state.status === 'signedIn' ? state.me.user.displayName : '';

  return (
    <header className="topbar">
      <nav className="tabs">
        <NavLink to="/" end>
          Home
        </NavLink>
        <NavLink to="/todos">Todos</NavLink>
        <NavLink to="/budget">Budget</NavLink>
        <NavLink to="/history">History</NavLink>
        <NavLink to="/categories">Categories</NavLink>
        <NavLink to="/security">Security</NavLink>
      </nav>
      <button className="link signout" onClick={() => void signOut()}>
        Sign out {name}
      </button>
    </header>
  );
}
